module.exports = __webpack_public_path__ + "media/v70ztp.4601c872.mp4";